import { createStore, createEvent } from "effector";

// Events
export const setLoading = createEvent<boolean>();
export const setIsMobileNavOpen = createEvent<boolean>();
export const setError = createEvent<string | null>();
export const setTheme = createEvent<"light" | "dark">();
export const setModalIsOpened = createEvent<boolean>();

// Toast events
export interface ToastMessage {
  id: string;
  type: "success" | "info" | "error" | "warning";
  text: string;
  duration?: number; // ms, default 5000
}

export const showToast = createEvent<Omit<ToastMessage, "id">>();
export const hideToast = createEvent<string>(); // toast id
export const clearAllToasts = createEvent();

// Store
interface AppState {
  loading: boolean;
  error: string | null;
  theme: "light" | "dark";
  modalIsOpened: boolean;
  toasts: ToastMessage[];
  isMobileNavOpen: boolean;
}

const initialState: AppState = {
  loading: false,
  error: null,
  theme: "light",
  modalIsOpened: false,
  toasts: [],
  isMobileNavOpen: false,
};

export const $appStore = createStore<AppState>(initialState)
  .on(setLoading, (state, loading) => ({ ...state, loading }))
  .on(setIsMobileNavOpen, (state, value) => {
    return { ...state, isMobileNavOpen: value };
  })
  .on(setError, (state, error) => ({ ...state, error }))
  .on(setTheme, (state, theme) => ({ ...state, theme }))
  .on(setModalIsOpened, (state, modalIsOpened) => ({ ...state, modalIsOpened }))
  .on(showToast, (state, toast) => ({
    ...state,
    toasts: [
      ...state.toasts,
      {
        ...toast,
        id: `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        duration: toast.duration ?? 10000,
      },
    ],
  }))
  .on(hideToast, (state, toastId) => ({
    ...state,
    toasts: state.toasts.filter((toast) => toast.id !== toastId),
  }))
  .on(clearAllToasts, (state) => ({ ...state, toasts: [] }));

// $appStore.watch((e) => console.log(e));
